import styled from "styled-components";

export const TitleAndTextEditorContainer = styled.div`
  padding-inline: 10%;
  box-sizing: border-box;
  height: 100%;
  place-content: center;
  margin-bottom: 216px;
`;
